import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ListChecks, ChevronRight, Flame } from "lucide-react";
import { api } from "@/lib/api";
import { DoneStamp } from "@/components/quest/DoneStamp";

export function useDailyBar(enabled) {
  const [m, setM] = useState(null);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!enabled) return undefined;
    const load = () => api.get("/missions").then(({ data }) => setM(data)).catch(() => {});
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 60000);
    return () => clearInterval(t);
  }, [enabled, pathname]);
  return enabled && m?.missions?.length ? m : null;
}

export const DailyMissionsBar = ({ m }) => {
  if (!m) return null;
  const total = m.missions.length;
  const done = m.missions.filter((x) => x.done).length;
  const pct = Math.round((done / total) * 100);
  return (
    <Link to="/feed?slot=missions" className="gold-bar h-9 flex items-center justify-center gap-1.5 sm:gap-2 px-2 sm:px-3 text-[#4a2a08] font-black text-[10px] sm:text-[13px] uppercase tracking-normal sm:tracking-wider" data-testid="daily-missions-bar">
      <ListChecks className="w-4 h-4 shrink-0" />
      <span className="truncate" data-testid="daily-missions-bar-text">Tägliche Missionen</span>
      <span className="shrink-0 inline-flex items-center gap-1.5">
        <span className="block w-14 sm:w-20 h-2 rounded-full bg-[#4a2a08]/20 overflow-hidden"><span className="block h-full rounded-full bg-[#4a2a08] transition-[width] duration-700" style={{ width: `${pct}%` }} data-testid="daily-missions-bar-fill" /></span>
        <span className="px-1.5 h-5 inline-flex items-center rounded-full bg-[#4a2a08] text-amber-200 text-[10px] sm:text-[11px] tabular-nums" data-testid="daily-missions-bar-count">{done}/{total}</span>
      </span>
      {m.streak > 0 && <span className="shrink-0 inline-flex items-center gap-0.5 px-1.5 h-5 rounded-full bg-gradient-to-r from-orange-500 to-red-500 text-white text-[10px] sm:text-[11px] tabular-nums" title={`${m.streak} Tage am Stück alle Missionen geschafft`} data-testid="daily-missions-streak"><Flame className="w-3 h-3 gold-bar-flicker" />{m.streak}</span>}
      {m.all_done && <DoneStamp small testId="daily-missions-done-stamp" />}
      <ChevronRight className="w-4 h-4 shrink-0" />
    </Link>
  );
};

export const DailyMissionsBarSpacer = ({ m }) => (m ? <div className="h-9" /> : null);
